module.exports = __webpack_public_path__ + "static/media/emotion-detect.9a91c7a8.png";